import React, { useEffect, useRef, useState } from 'react'
import {
  Layout,
  Badge,
  message,
  Col,
  Row,
  Tabs,
  Button,
  Modal,
  Input,
} from 'antd'
import { sendHttpPostRequest } from '../../api/http-request'

import courseMainStyles from './course-main.module.less'
import * as constants from '../../constants/constants'
import './course.module.css'
import { MenuPreview } from './menu/course-main-teacher-menu'
import {
  ClockCircleOutlined, CalendarOutlined,
  TeamOutlined,
  ExperimentOutlined,
  CheckCircleOutlined,
  PlayCircleOutlined,
  LockOutlined
} from '@ant-design/icons'
import Feedback from '../common/feedback-help/feedback'

import Draggable from 'react-draggable'
import CourseMainStudentSlides from './slides/course-main-student-slides'
import CourseMainStudentCases from './case/course-main-student-cases'
import CourseMainStudentTestList from './test/course-main-student-test-list'
import CourseMainStudentExamList from './exam/course-main-student-exam-list'
import Cookies from 'js-cookie'
import { checkUserLogin } from '../common/user-center/user-info'
import LockedMenuPreview from './menu/locked-course-menu-preview'
import CourseMainMemberList from './member/course-main-memberlist'
import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '../../constants/constants'

import { CourseMainTeacherTestList } from './test/course-main-teacher-test-list'
import CourseMainTeacherExamList from './exam/course-main-teacher-exam-list'
import CourseMainTeacherStudent from './student-list/course-main-teacher-student'

import Icon from '@ant-design/icons'
import  {ReactComponent as mymenuSvg }   from '../../static/image/course/mymenu.svg'
import { ReactComponent as myslidesSvg }   from '../../static/image/course/myslides.svg'
import { ReactComponent as mytestSvg }   from '../../static/image/course/mytest.svg'
import { ReactComponent as myexamSvg }   from '../../static/image/course/myexam.svg'
import { ReactComponent as myteamSvg }   from '../../static/image/course/myteam.svg'
import { ReactComponent as mysettingSvg }   from '../../static/image/course/mysetting.svg'

const mymenuIcon = (props:any) => (<Icon component={mymenuSvg} {...props} />)
const myslidesIcon = (props:any) => (<Icon component={myslidesSvg} {...props} />)
const mytestIcon = (props:any) => (<Icon component={mytestSvg} {...props} />)
const myexamIcon = (props:any) => (<Icon component={myexamSvg} {...props} />)
const myteamIcon = (props:any) => (<Icon component={myteamSvg} {...props} />)
const mysettingIcon = (props:any) => (<Icon component={mysettingSvg} {...props} />)


const { TabPane } = Tabs

export interface Props {}

const default_avatar = '/static/image/avatar/default_avatar.png' // 默认用户头像

/** 学生课程主页面 */
export const CourseMainStudent: React.FC<Props> = (props) => {
  const courseId = parseInt(window.location.search.split('&')[0].split('=')[1]) // 课程ID
  const tabKey = window.location.search.split('&')[1]
    ? window.location.search.split('&')[1].split('=')[1]
    : '1' // 标签页key
  const [course, setCourse] = useState(null as any) //课程信息

  const [currentUser, setCurrentUser] = useState(null as any) //当前用户的信息

  const [userInfo, setUserInfo] = useState(null as any) //当前用户的信息

  const [teacherList, setTeacherList] = useState([] as any[]) //保存课程教师列表
  const [studentList, setStudentList] = useState(null as any) //保存课程学生列表
  const [totalSum, setTotalSum] = useState(0) // 成员数

  const [realName, setRealName] = useState(null as any) //真实姓名
  const [realNumber, setRealNumber] = useState(null as any) //学号

  const [collegeId, setCollegeId] = useState(null as any) //学生信息
  const [userId, setUserId] = useState(null as any) //当前教师信息
  const [assistant, setAssistant] = useState(null as any) //助教信息

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isImproveModalVisible, setIsImproveModalVisible] = useState(false)
  const [isApplyModalVisible, setIsApplyModalVisible] = useState(false)
  const [isCheckedModalVisible, setIsCheckedModalVisible] = useState(false)
  const [inApply, setInApply] = useState(false)

  useEffect(() => {
    queryCourse()
    queryCurrentUserInfo()
    queryUserInfo()
    /** 查询机构Id */
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response?.college_info?.college_id) {
          let _collegeId = response.college_info.college_id
          setCollegeId(_collegeId)
        }
        if (response?.teacher_info?.user_id) {
          let _userId = response.teacher_info.user_id
          setUserId(_userId)
          console.log('_userId', _userId);
          
        }
      }
    )
    sendHttpPostRequest(
      'course/api/get_student_role',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: courseId,
      },
      (response: any) => {
        if (response.code == 0) {
          setAssistant(response.data.is_assistant)
        }
      }
    )
  }, [])

  const queryCurrentUserInfo = () => {
    sendHttpPostRequest(
      'account/api/check_login/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/login?next=course';
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
          // window.location.href = '/login?next=course';
        } else if (response.is_ok == true) {
          setCurrentUser(response)
          queryCourseStudentList()
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 查询用户信息回调
  const queryUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      setUserInfo(response.data)
      setRealName(response.data.real_name)
      setRealNumber(response.data.number)
    } else {
      message.error(response.message)
    }
  }

  // 查询用户信息
  const queryUserInfo = () => {
    sendHttpPostRequest(
      'account/api/get_user_info/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      queryUserInfoCallback
    )
  }

  // 保存用户信息回调
  const saveUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      message.success('更新用户信息成功')
      // 重设localStorage
      queryUserInfo()
    } else {
      message.error(response.message)
    }
  }

  // 保存用户信息
  const saveUserInfo = () => {
    sendHttpPostRequest(
      'account/api/update_user_info/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        user_id: userInfo?.user_id,
        real_name: realName,
        number: realNumber,
      },
      saveUserInfoCallback
    )
  }

  const queryCourseStudentCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
    } else if (response.is_ok == true) {
      setStudentList(response.query_list.filter((item) => item.role == '学生'))
      setTeacherList(response.query_list.filter((item) => item.role == '教师'))
      setTotalSum(response.total_sum)
    } else {
      message.error(response.message)
    }
  }

  const queryCourseStudentList = () => {
    sendHttpPostRequest(
      'course/api/user_query_course_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: courseId,
        type: 0, //0查学生，1,查教师
      },
      queryCourseStudentCallback
    )
  }

  const queryCourseTeacherCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=course';
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else if (response.is_ok == true) {
      setTeacherList(response.query_list)
    } else {
      message.error(response.message)
    }
  }



  const sentApplyCourseRequest = () => {
    setInApply(true)
    sendHttpPostRequest(
      'course/api/user_apply_course',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: courseId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          // 成功
          setInApply(true)
          queryCourse()
          queryCurrentUserInfo()
          queryUserInfo()
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/login?next=course'
        } else if (response.status == 1) {
          // 申请开关为开放
          //window.location.reload();
          queryCourse()
          queryCurrentUserInfo()
          queryUserInfo()
        } else if (response.status == 0) {
          //window.location.reload();
          // setIsCheckedModalVisible(true);
          queryCourse()
          queryCurrentUserInfo()
          queryUserInfo()
        } else if (response.status == 2) {
          //window.location.reload();
          setInApply(false)
          queryCourse()
          queryCurrentUserInfo()
          queryUserInfo()
        } else {
          message.error(response.message)
        }
      }
    )
  }
  /** 点击了申请加入按钮，点击了提交按钮 */
  const handleOk = () => {
    setIsModalVisible(false)
    //1.检查真实姓名和学号是否未设置
    if (realName == '' || realNumber == '') {
      setIsImproveModalVisible(true)
    } else {
      sentApplyCourseRequest()
    }
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    setIsApplyModalVisible(false)
    setIsCheckedModalVisible(false)
  }

  const handleImproveOk = () => {
    setIsModalVisible(false)
    setIsImproveModalVisible(false)
    saveUserInfo() //保存用户信息
    sentApplyCourseRequest()
  }

  const handleImproveCancel = () => {
    setIsModalVisible(false)
    setIsImproveModalVisible(false)
  }

  const handleApplyOk = () => {
    setIsModalVisible(false)
    setIsApplyModalVisible(false)
    setIsCheckedModalVisible(false)
  }

  const handleApplyCancel = () => {
    setIsModalVisible(false)
    setIsApplyModalVisible(false)
    setIsCheckedModalVisible(false)
    sendHttpPostRequest(
      'course/api/user_cancel_apply_course',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: courseId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/login?next=/course';
        } else if (response.is_ok == true) {
          // 成功
          setInApply(false)
          if (response.status == 1) {
            // 申请开关为开放
            window.location.reload()
          } else {
            message.error(response.message)
          }
        } else if (response.code == -501) {
          // 权限不足
          // window.location.href = '/login?next=course';
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const handleCheckedOk = () => {
    setIsModalVisible(false)
    setIsApplyModalVisible(false)
    setIsCheckedModalVisible(false)
  }

  const draggleRef = useRef<HTMLDivElement | null>(null)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  // 查询课程信息
  const queryCourse = () => {
    const sessionid = Cookies.get('sessionid')
    const queryData = {
      source: 1,
      course_id: courseId,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest(
      'course/api/user_query_course_by_id',
      queryData,
      courseCallback
    )
  }

  // 查询课程接口回调
  const courseCallback = (response: any) => {
    console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=/course';
    } else if (response.is_ok == true) {
      // 成功
      setCourse(response.query_info)
    } else if (response.code == -501) {
      // 权限不足
      // window.location.href = '/login?next=course';
    } else {
      message.error(response.message)
    }
  }

  const applyIn = () => {
    if (course?.apply_info?.status == 0) {
      setIsCheckedModalVisible(true)
    } else if (course?.apply_info?.status == 1) {
      setIsApplyModalVisible(true)
    } else {
      setIsModalVisible(true)
    }
  }

  const startStudy = () => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      if (course.recent_knowledge_url != '') {
        window.location.href = course.recent_knowledge_url
      } else if (course.first_knowledge_url != '') {
        window.location.href = course.first_knowledge_url
      } else {
        message.destroy()
        message.error('课程暂时无法学习，请稍候...')
      }
    }
  }


  const BtnContent: React.FC<Props> = (props) => {
    if (
      course?.course_status == '未开始' &&
      !inApply &&
      course?.is_course_student == false
    ) {
      return (
        
          <span
            className={courseMainStyles.BtnDark}
            onClick={applyIn}
          >
            {'申请加入'}
          </span>
        
      )
    } else if (
      course?.course_status == '未开始' &&
      inApply &&
      course?.is_course_student == false
    ) {
      return (
        
          <span
            className={courseMainStyles.BtnDark}
            onClick={applyIn}
          >
            等待审核
          </span>
        
      )
    } else if (
      course?.course_status == '未开始' &&
      course?.is_course_student == true
    ) {
      return (
          <span
            className={courseMainStyles.BtnDark}
          >
            等待开课
          </span>
       
      )
    } else if (
      course?.course_status == '进行中' &&
      course?.is_course_student == true
    ) {
      return (
          <span
            className={courseMainStyles.BtnDark}
            onClick={startStudy}
          >
            开始学习
          </span>
      )
    } else if (
      course?.course_status == '进行中' &&
      !inApply &&
      course?.is_course_student == false
    ) {
      return (
          <span
            className={courseMainStyles.BtnDark}
            onClick={applyIn}
          >
            {'申请加入'}
          </span>
      )
    } else if (
      course?.course_status == '进行中' &&
      inApply &&
      course?.is_course_student == false
    ) {
      return (
          <span
            className={courseMainStyles.BtnDark}
            onClick={applyIn}
          >
            等待审核
          </span>
      )
    } else if (
      course?.course_status == '已结束' &&
      course?.is_course_student == false
    ) {
      return (
          <span
            className={courseMainStyles.BtnDisable}
          >
            已结课
          </span>
      )
    } else if (
      course?.course_status == '已结束' &&
      course?.is_course_student == true
    ) {
      return (
          <span
            className={courseMainStyles.BtnDisable}
            onClick={startStudy}
          >
            已结课
          </span>
      )
    } else {
      return <></>
    }
  }

  const CourseStatus = () => {
    if (
      course?.course_status == '未开始' &&
      course?.is_course_student == true
    ) {
      return (
        <span
          className={courseMainStyles.studentCourseStatus}
          style={{color:'#ff9f43',  backgroundColor: '#ff9f431a' }}
        >
          <ClockCircleOutlined /> {'未开课'}
        </span>
      )
    } else if (
      course?.course_status == '未开始' &&
      course?.is_course_student == false
    ) {
      return (
        <span
          className={courseMainStyles.studentCourseStatus}
          style={{color:'#6b7280', backgroundColor: '#6b72801a' }}
        >
          <LockOutlined /> {'未加入'}
        </span>
      )
    } else if (
      course?.course_status == '进行中' &&
      course?.is_course_student == true
    ) {
      return (

          <span
            className={courseMainStyles.studentCourseStatus}
            style={{
              color:'#0ea5e9', 
              backgroundColor: '#0ea5e91a',
              display: 'inline-block',
              marginRight: 20,
            }}
          >
            <PlayCircleOutlined /> {course?.course_status}
          </span>
       
      )
    } else if (
      course?.course_status == '进行中' &&
      course?.is_course_student == false
    ) {
      return (
        <span
          className={courseMainStyles.studentCourseStatus}
          style={{color:'#6b7280',  backgroundColor: '#6b72801a' }}
        >
          <LockOutlined /> {'未加入'}
        </span>
      )
    } else if (course?.course_status == '已结束') {
      return (
        <span
          className={courseMainStyles.studentCourseStatus}
          style={{
            color:'#10b981', 
            backgroundColor: '#10b9811a',
            display: 'inline-block',
            marginRight: 20,
          }}
        >
          <CheckCircleOutlined /> {'已结课'}
        </span>
      )
    } else {
      return <span></span>
    }
  }


  return (
    <Layout className={courseMainStyles.mainDiv} >
      <div className={courseMainStyles.courseHeaderWrapper}>
        <Row
          className={courseMainStyles.courseInfoDiv}
          align="middle"
          wrap={false}
        >

          <Col flex="auto">
            <div className={courseMainStyles.courseName}>{course?.name} {CourseStatus()} </div>
          

            <div > 
              <Row wrap={false} align="middle" style={{marginBottom:24}} >   
                  <Col flex="40px" style={{marginRight:12}}> 
                    <div>
                      <img
                          style={{height:40, width:40, borderRadius:'50%'}}
                          className={GlobalCss.avatar}
                          src={BACKEND_API_URL + course?.teacher_avatar} 
                      /> 
                    </div>
                  </Col>
                  <Col flex="120px">
                    <div style={{textAlign:'left'}}>
                      <div style={{fontSize:14, color:'#6b7280'}}>主讲教师</div> 
                      <div className={courseMainStyles.courseTeacherName}>{course?.teacher_real_name == '' ? course?.teacher : course?.teacher_real_name}</div>
                    </div>
                  </Col>

                  <Col flex={'360px'} style={{marginRight:12}}>
                    <div className={courseMainStyles.datecourse}>
                      <CalendarOutlined  style={{color:'#07c160', marginRight:5}}/> 
                      开课时间：{course?.start_time?.slice(0, 10)} 至 {course?.end_time?.slice(0, 10)}
                    </div>
                </Col>

                { course?.code &&  <Col flex={"200px"}>
                  <div> 
                   课程编号： {course?.code}
                  </div>
                </Col>}

                { course?.class &&  <Col flex={"200px"}>
                  <div> 
                   班级： {course?.class}
                  </div>
                </Col>}

              </Row>

            </div>

            <div style={{margin:'0 0 8px', fontSize:18, fontWeight:600}}>课程简介</div>
            <div title= {course?.description} className={courseMainStyles.courseIntroduction} style={{marginBottom:0}}> 
              {course?.description}
            </div>


            
          </Col>


          <Col flex="300px" style={{ marginLeft: 16, textAlign: "right" }}>
            <div >
              <div>
              <img
                src={
                  course?.cover && course?.cover?.startsWith('http')
                    ? course?.cover
                    : constants.BACKEND_URL + course?.cover
                }

                className={courseMainStyles.courseImage}
              />
              </div>

 

            </div>
          </Col>
        </Row>
        <div className={courseMainStyles.headerActionDiv} >
              <BtnContent />
          </div>


      </div>

      <div className={courseMainStyles.courseTabsWrapper}>
        {course?.course_status == '未开始' &&
          course?.is_course_student == true && (
            <Tabs
  
              defaultActiveKey={tabKey}
              //type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane
                tab={<div> <Icon component={mymenuIcon}/>  大纲</div>}
                key="1"
              >
                  <div>
                  <LockedMenuPreview
                    menu_id={course?.syllabus_id}
                  ></LockedMenuPreview>
                </div>
              </TabPane>

            </Tabs>
          )}
        {course?.course_status == '未开始' &&
          course?.is_course_student == false && (
            <Tabs
              
              defaultActiveKey={tabKey}
              //type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane
                tab={<div > <Icon component={mymenuIcon}/>  大纲</div>}
                key="1"
              >
                <div >
                
                <LockedMenuPreview
                  menu_id={course?.syllabus_id}
                ></LockedMenuPreview>
                </div>
              </TabPane>
            </Tabs>
          )}
        {course?.course_status == '进行中' &&
          course?.is_course_student == true && (
            <Tabs
              defaultActiveKey={tabKey}
              //type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane tab={<div> <Icon component={mymenuIcon}/>  大纲</div>} key="1">
                <div >
                  <MenuPreview
                    menu_id={course?.syllabus_id}
                    course_id={course?.id}
                    course_user={'student'}
                    course_status={'进行中'}
                  />
                </div>
              </TabPane>
              <TabPane tab={<div> <Icon component={myslidesIcon}/>  课件</div>} key="2">
                <CourseMainStudentSlides course_id={course?.id} />
              </TabPane>
              <TabPane tab={<div> <ExperimentOutlined /> 实验</div>} key="3">
                <CourseMainStudentCases course_id={course?.id} />
              </TabPane>
              <TabPane tab={<div> <Icon component={mytestIcon}/>  作业</div>} key="4">
                {assistant == 0 && collegeId && 
                  <CourseMainStudentTestList
                    course_id={courseId}
                    college_id={collegeId}
                    menu_id={course?.syllabus_id}
                  />
                }
                {assistant != 0 && collegeId && (
                  <CourseMainTeacherTestList
                    course_id={courseId}
                    college_id={collegeId}
                    menu_id={course?.syllabus_id}
                    assistant={assistant}
                  />
                )}
              </TabPane>
              <TabPane tab={<div> <Icon component={myexamIcon}/>  考试</div>} key="5">
                {assistant == 0 && collegeId && 
                  <CourseMainStudentExamList course_id={course?.id} />
                }
                {assistant != 0 && collegeId && 
                  <CourseMainTeacherExamList
                    course_id={courseId}
                    college_id={collegeId}
                    enable_exam={course?.enable_exam}
                    menu_id={course?.syllabus_id}
                    assistant={assistant}
                  />
                }
              </TabPane>

              <TabPane
                tab={
                  <div className={courseMainStyles.dotBadgeWrapper}>
                  <Badge
                    style={{ backgroundColor: '#ff4b50', right:-5, color:'#ff4d50'}}
                    count={assistant ? course?.apply_count : 0}
                    size="small"
                    offset={[10, 0]}
                  >
                    <div> <TeamOutlined/>    {'成员'}</div>
                  </Badge>
                  </div>
                }
                key="11"
              >
                {assistant == 0 && collegeId && 
                  <CourseMainMemberList
                    course_id={courseId}
                  />
                }
                {assistant != 0 && collegeId && 
                  <CourseMainTeacherStudent
                    course_id={course?.id}
                    assistant={assistant}
                    is_course_teacher={course?.is_course_teacher}
                    user_id={userId}
                    teacher_id={course.teacher_id}
                    actionCallback={queryCourse}
                  />}
              </TabPane>
            </Tabs>
          )}
        {course?.course_status == '进行中' &&
          course?.is_course_student == false && (
            <Tabs
              
              defaultActiveKey={tabKey}
              //type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane
                tab={<div><Icon component={mymenuIcon}/>  大纲</div>}
                key="1"
              >
                <div >
                  <LockedMenuPreview
                    menu_id={course?.syllabus_id}
                  ></LockedMenuPreview>
                </div>
              </TabPane>
            </Tabs>
          )}
        {course?.course_status == '已结束' &&
          course?.is_course_student == false && (
            <Tabs
              
              defaultActiveKey={'1'}
              //type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane tab={<div><Icon component={mymenuIcon}/>  大纲</div>} key="1">
              <div >
                <LockedMenuPreview
                  menu_id={course?.syllabus_id}
                ></LockedMenuPreview>
                </div>
              </TabPane>

            </Tabs>
          )}

        {course?.course_status == '已结束' &&
          course?.is_course_student == true && (
            <Tabs
             
              defaultActiveKey={tabKey}
              //type="card"
              size="middle"
              tabPosition="top"
            >
              <TabPane tab={<div> <Icon component={mymenuIcon}/> 大纲</div>} key="1">
              <div >
                <LockedMenuPreview
                  menu_id={course?.syllabus_id}
                ></LockedMenuPreview>
                </div>
              </TabPane>
              <TabPane tab={<div><Icon component={myslidesIcon}/>  课件</div>} key="2">
                <CourseMainStudentSlides course_id={course?.id} />
              </TabPane>
              <TabPane tab={<div> <ExperimentOutlined /> 实验</div>} key="3">
                <CourseMainStudentCases course_id={course?.id} />
              </TabPane>
              <TabPane tab={<div><Icon component={mytestIcon}/>  作业</div>} key="4">
                {!assistant && collegeId && (
                  <CourseMainStudentTestList
                    course_id={courseId}
                    college_id={collegeId}
                    menu_id={course?.syllabus_id}
                  />
                )}
                {assistant && collegeId && (
                  <CourseMainTeacherTestList
                    course_id={courseId}
                    college_id={collegeId}
                    menu_id={course?.syllabus_id}
                    assistant={assistant}
                  />
                )}
              </TabPane>
              <TabPane tab={<div><Icon component={myexamIcon}/> 考试</div>} key="5">
                {!assistant && collegeId && (
                  <CourseMainStudentExamList course_id={course?.id} />
                )}
                {assistant && collegeId && (
                  <CourseMainTeacherExamList
                    course_id={courseId}
                    college_id={collegeId}
                    enable_exam={course?.enable_exam}
                    menu_id={course?.syllabus_id}
                    assistant={assistant}
                  />
                )}
              </TabPane>


              <TabPane tab={<div> <TeamOutlined/>   成员</div>} key="11">
                <CourseMainMemberList
                  actionCallback={queryCourseStudentList}
                  studentList={studentList}
                  teacherList={teacherList}
                />
              </TabPane>
            </Tabs>
          )}
      </div>



      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            申请加入
          </div>
        }
        width={450}
        closable={false}
        open={isModalVisible}
        className={courseMainStyles.modal}
        footer={
          <div>
            <Button
              className={courseMainStyles.stepsBtn}
              style={{ marginRight: 20              , textShadow:'none',
                boxShadow:'none'}}
              type="default"
              onClick={handleCancel}
            >
              取消
            </Button>
            <Button
              className={courseMainStyles.stepsBtn}
              style={{ marginRight: 20, color: '#fff' ,  textShadow:'none',
                boxShadow:'none'}}
              type="primary"
              onClick={handleOk}
            >
              提交
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        <div style={{ margin: '0 auto', width: 250, lineHeight:'32px' }}>
          <div > 课程名称：{course?.name}</div>
          <div>
            授课老师：
            <span><img
                className={GlobalCss.avatar}
                src={BACKEND_API_URL + course?.teacher_avatar}
                alt=""
            /> </span>
           
            {course?.teacher_real_name == ''
              ? course?.teacher
              : course?.teacher_real_name}
          </div>
          <div>
            开课时间：{course?.start_time.slice(0, 10)}至
            {course?.end_time.slice(0, 10)}
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            完善个人信息
          </div>
        }
        width={450}
        closable={false}
        open={isImproveModalVisible}
        className={courseMainStyles.modal}
        footer={
          <div>
            <Button
              className={courseMainStyles.stepsBtn}
              style={{ marginRight: 20, textShadow:'none',
                boxShadow:'none' }}
              type="default"
              onClick={handleImproveCancel}
            >
              取消
            </Button>
            <Button
              className={courseMainStyles.stepsBtn}
              style={{ marginRight: 20, color: '#fff' }}
              type="primary"
              onClick={handleImproveOk}
            >
              提交
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        <Row align="middle" style={{ margin: '0 auto 10px', width: 300 }}>
          <Col flex="80px">真实姓名</Col>
          <Col flex="auto">
            <Input
              value={realName}
              onChange={(e) => {
                setRealName(e.target.value)
              }}
              placeholder="请输入真实姓名"
              style={{ borderRadius: 4 }}
            />
          </Col>
        </Row>
        <Row align="middle" style={{ margin: '0 auto 20px', width: 300 }}>
          <Col flex="80px">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</Col>
          <Col flex="auto">
            <Input
              value={realNumber}
              onChange={(e) => {
                setRealNumber(e.target.value)
              }}
              placeholder="请输入学号"
              style={{ borderRadius: 4 }}
            />
          </Col>
        </Row>
        <div
          style={{
            color: '#999',
            margin: '0 auto',
            width: 300,
            textAlign: 'center',
          }}
        >
          便于教学，请输入真实姓名和学号
        </div>
      </Modal>

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            提示
          </div>
        }
        width={450}
        closable={false}
        visible={isApplyModalVisible}
        className={courseMainStyles.modal}
        footer={
          <div>
            <Button
              className={courseMainStyles.stepsBtn}
              style={{ marginRight: 20 }}
              type="default"
              onClick={handleApplyCancel}
            >
              撤销
            </Button>
            <Button
              className={courseMainStyles.stepsBtn}
              style={{ marginRight: 20, color: '#fff' }}
              type="primary"
              onClick={handleApplyOk}
            >
              确认
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        <div style={{ margin: '0 auto', textAlign: 'center', width: 235 }}>
          <p>已发出申请，等待老师审核</p>
          <p style={{ fontSize: 12, color: '#ccc' }}>5分钟内可撤回该申请</p>
        </div>
      </Modal>

      <Modal
        title={
          <div
            style={{ width: '100%', cursor: 'move' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false)
              }
            }}
            onMouseOut={() => {
              setDisabled(true)
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            提示
          </div>
        }
        width={450}
        closable={false}
        visible={isCheckedModalVisible}
        className={courseMainStyles.modal}
        footer={
          <div>
            <Button
              className={courseMainStyles.stepsBtn}
              style={{ marginRight: 20, color: '#fff' }}
              type="primary"
              onClick={handleCheckedOk}
            >
              确认
            </Button>
          </div>
        }
        modalRender={(modal) => (
          <div>
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>{' '}
          </div>
        )}
      >
        <div style={{ margin: '0 auto', textAlign: 'center', width: 235 }}>
          <p>老师已拒绝</p>
          <p>请先学习其他课程吧</p>
        </div>
      </Modal>

      <Feedback />
    </Layout>
  )
}

export default CourseMainStudent
